import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { ComingSoonSection } from '../components/ComingSoonSection';
import { PillarsSection } from '../components/PillarsSection';
import { MotionLabSection } from '../components/MotionLabSection';
import { AcademySection } from '../components/AcademySection';
import { ScoutingSection } from '../components/ScoutingSection';
import { GoatsSection } from '../components/GoatsSection';
import { GallerySection } from '../components/GallerySection';
import { FounderSection } from '../components/FounderSection';
import { ContactSection } from '../components/ContactSection';
import { FooterSection } from '../components/FooterSection';
import { Toaster } from '../components/ui/sonner';

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Header />
      <HeroSection />
      <ComingSoonSection />
      <PillarsSection />
      <MotionLabSection />
      <AcademySection />
      <ScoutingSection />
      <GoatsSection />
      <GallerySection />
      <FounderSection />
      <ContactSection />
      <FooterSection />
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}
